module.exports = __webpack_public_path__ + "static/media/finance.d2ea30c1.jpg";